import React from 'react'

export interface MarkerProps extends React.DOMAttributes<HTMLElement> {
  themeColor?: 'primary' | 'secondary' | 'accent'
  blocked?: boolean
}

export function Marker(props: MarkerProps) {
  let style: string
  switch (props.themeColor) {
    case 'primary': style = 'pcy-marker pcy-font-small pcy-marker-primary'; break
    case 'secondary': style = 'pcy-marker pcy-font-small pcy-marker-secondary'; break
    case 'accent': style = 'pcy-marker pcy-font-small pcy-marker-accent'; break
    default: style = 'pcy-marker pcy-font-small'; break
  }

  return (
    <div className={style} style={{ display: props.blocked ?? false ? 'block' : 'inline' }}>
      {props.children}
    </div>
  )
}
